import PropTypes from 'prop-types';
import LabelTextInline from '../../utils/LabelTextInline/LabelTextInline';
import { isEmpty } from 'lodash';

const ServiceAreas = ({
  className = '',
  service_areas = [],
  intlProvider = {},
}) => {
  const nationalServiceArea = service_areas.find(sA => sA.service_area_type === 'national');
  const statesServiceAreas = service_areas.filter(sA => sA.service_area_type === 'state').map(sA => sA.name);

  return (
    <div className={`${className} text-brand-blue font-normal text-sm`}>
      <div>
        <h4 className="mb-1 font-medium font-heavy-font">
          {!isEmpty(intlProvider) ? (
            intlProvider.formatMessage({
              id: "J6BEWS",
              description: "service-areas",
              defaultMessage: "Service Areas"
            })
          ) : "Service Areas"}
        </h4>
        {nationalServiceArea &&
          <div>
            <LabelTextInline
              className="mb-1 flex"
              label={!isEmpty(intlProvider) ? (
                intlProvider.formatMessage({
                  id: "SqRb6P",
                  description: "national",
                  defaultMessage: "National"
                })
              ) : 'National'}
              content={!isEmpty(intlProvider) ? (
                intlProvider.formatMessage({ 
                  id: "VTO8h4",
                  description: "content-text",
                  defaultMessage: "This program serves the entire country"
                })
              ) : 'This program serves the entire country'}
            />
          </div>
        }
        {!nationalServiceArea &&
          <div>
            { statesServiceAreas.length > 0 &&
              <LabelTextInline
                className="mb-1 flex"
                label={!isEmpty(intlProvider) ? (
                  intlProvider.formatMessage({
                    id: "XW82Wp",
                    description: "states",
                    defaultMessage: "States"
                  })
                ) : 'States'}
                content={statesServiceAreas}
              />
            }
          </div>
        }
      </div>
    </div>
  );
};

ServiceAreas.propTypes = {
  className: PropTypes.string,
  /** Array of Service Areas objects. It can contain National Service area if the program serves the entire country, States or Cities */
  service_areas: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      program: PropTypes.shape({
        id: PropTypes.string,
      }),
      service_area_type: PropTypes.string,
      state_abbreviation: PropTypes.string,
    }),
  ),
  intlProvider: PropTypes.shape({
    locale: PropTypes.string,
    messages: PropTypes.object,
    formatMessage: PropTypes.func,
  }),
};

export default ServiceAreas;
